"use client";

import { BuildAgentForFreeButton } from "~/components/marketplace/build-agent-for-free-button";
import { DemoCTA, PrimaryCTA, TextLinkCTA } from "~/components/siteglue/siteglue-cta";
import { getMarketingChrome } from "~/lib/siteglue/marketing-chrome";
import { SITEGLUE_VALUE_PROP_TEAM } from "~/lib/siteglue/adapt-marketing-copy";
import { cn } from "~/lib/utils";

type MarketingExploreCtaProps = {
  className?: string;
  testId?: string;
};

export function MarketingExploreCta({
  className,
  testId = "marketing-explore-cta",
}: MarketingExploreCtaProps) {
  const chrome = getMarketingChrome();
  const isSiteGlue = chrome.brandId === "siteglue";

  return (
    <div
      className={cn(
        "rounded-xl border border-border bg-gradient-to-br from-primary/8 via-background to-slate-50 p-8 sm:p-10",
        className,
      )}
      data-testid={testId}
    >
      <div className="mx-auto max-w-xl text-center">
        <h2 className="text-2xl font-bold tracking-tight sm:text-3xl">
          {isSiteGlue
            ? "Ready to put SiteGlue to work?"
            : "Onboard an Inbound GPT Agent in minutes"}
        </h2>
        <p className="mt-3 leading-relaxed text-muted-foreground">
          {isSiteGlue
            ? `Create an AI employee that works alongside your team while keeping a human in the loop — ${SITEGLUE_VALUE_PROP_TEAM.toLowerCase()}.`
            : "We'll customize your Inbound GPT Agent to answer questions, gather information, schedule appointments and connect people to the right human at your company."}
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          {isSiteGlue ? (
            <>
              <PrimaryCTA location="final_cta" testId="link-cta-build-agent-free" />
              <DemoCTA location="final_cta" testId="link-cta-live-demo" />
            </>
          ) : (
            <BuildAgentForFreeButton
              className="h-12 gap-2 px-8"
              testId="link-cta-build-agent-free"
              showArrow
            />
          )}
        </div>
        {isSiteGlue ? (
          <div className="mt-5 flex justify-center">
            <TextLinkCTA action="bookDemo" location="final_cta" label="Or book a demo" />
          </div>
        ) : null}
      </div>
    </div>
  );
}
